import { useState, useEffect, useRef } from 'react'
import style from './index.module.scss'
import { Input, message, Modal } from 'antd'
import { KeyOutlined, EditFilled, CheckOutlined, LinkOutlined, PlusSquareOutlined, CloseOutlined, UserOutlined, UploadOutlined } from '@ant-design/icons';
import user_default from '../../static/image/user_default.png'
import * as apis from '../../api/user'
import { addFileRow } from '../../api/common'
import EditPassWord from './editPassWord/index'
import { getImgUrlById } from '../../util'

import PopCheck from './popCheck/index'
import InitUpload from '../../components/upload'

import baidu from '../../static/image/baidu.png'
import { StorageModule } from '../../modules/storage';
import { getImage } from '../../util';
import useStore from '../../store/useStore'

interface Props {
    visible: any;
    onClose: () => void
}

interface State {
    userInfo: any
    net_disk_list: any[]

}

const MySelf = (props: Props) => {
    const [state, setState] = useState<State>({
        userInfo: {},
        net_disk_list: []
    });
    const [nameVisible, setNameVisible] = useState<boolean>(false);
    const [passVisible, setPassVisible] = useState<boolean>(false);
    const [phoneVisible, setPhoneVisible] = useState<boolean>(false);
    const [emailVisible, setEmailVisible] = useState<boolean>(false);
    const [netdiskVisible, setNetdiskVisible] = useState<boolean>(false);
    const [itemInfo, setItemInfo] = useState<any>(null);
    // const [attachInfo, setAttachInfo] = useState<any>();
    const [tx, setTx] = useState<any>('');

    const inputRef = useRef<any>()

    const [username, setUsername] = useState<any>();

    // const [tx, setTx] = useState<any>();

    const [delPhone, setDelPhone] = useState<boolean>(false)
    const [delEmail, setDelEmail] = useState<boolean>(false)
    const [infoShow, setInfoShow] = useState<boolean>(false)
    const { store, dispatch } = useStore();


    useEffect(() => {
        if (props.visible) {
            init()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.visible])
    useEffect(() => {
        setTx(state.userInfo.avatar)
    }, [state.userInfo.avatar])
    /**
    * @name 初始化
    */
    const init = () => {
        getInfo()
        // onEndpoint()
    }
    /**
    * @name 获取网盘信息
    */

    const onEndpoint = async (): Promise<void> => {
        try {
            let res: any = await apis.endpoint()
            if (res.ok) {
                state.net_disk_list = res.data
                state.net_disk_list.map(i => i.select = false)
                setState({ ...state })
            }
        } catch (err) { }
    }
    /**
    * @name 获取用户信息
    */
    const getInfo = async (): Promise<void> => {
        try {
            let response: any = await apis.myself()
            state.userInfo = response.data
            setUsername(state.userInfo.username)
            setState({ ...state })
            // setAttachInfo(state.userInfo.attachInfo)
            reset()
            setState({ ...state })
            StorageModule.setUser(state.userInfo);
            dispatch({
                type: 'SET_USERINFO',
                data: state.userInfo
            });
        } catch (err) { }
    }
    /**
    * @name 重置未修改用户名
    */
    const reset = () => {
        setNameVisible(false)
        setUsername(state.userInfo.username)
    }
    /**
    * @name 监听输入文字
    */
    const onChange = (e: any, fun: any): void => {
        // item.orititle = item.title
        // item.title = e.target.value
        // setState({ ...state })
        fun(e.target.value)
    }
    /**
    * @name 修改头像
    */
    const onMyselfAvatar = async (e: any): Promise<any> => {
        try {
            let response: any = await apis.myselfAvatar(e)
            if (response.ok) {
                message.success('修改成功')
                getInfo()
            }
        } catch (err) { }

    }
    // /**
    // * @name 修改用户昵称
    // */
    // const onNickName = async (): Promise<any> => {
    //     console.log("//")
    //     try {
    //         let response: any = await apis.nickname(username)
    //         console.log(response)
    //         if (response.ok) {
    //             message.success('修改成功')
    //             getInfo()
    //         }
    //     } catch (err) { }

    // }
    /**
    * @name 修改用户登录名
    */
    const onUserName = async (): Promise<any> => {
        if (!username) {
            message.error('用户名不可设置为空')
            return
        }
        try {
            let response: any = await apis.username(username)
            if (response.ok) {
                message.success('修改成功')
                getInfo()
            }
        } catch (err) { }

    }
    const onAddNetDiskClick = async () => {
        try {
            let res: any = await apis.authLink()
            if (res.ok) {
                onEndpoint();
                window.location.href = res.data;
            }
        } catch (err) { }
    }

    return (
        <Modal
            className={style.selection_list}
            onCancel={() => {
                props.onClose()
            }}
            title={'我的'}
            width={'650px'}
            footer={null}
            open={props.visible}>

            <div data-flex='main:justify' className={style.myInfo}>
                <div className='wp-50'>
                    <div data-flex="main:left cross:center" className=' mt-20 '>
                        <div className={style.lable}>我的头像</div>
                        <div className='pos-r'>
                            <div className={style.user_upload} >
                                <span className={style.user_upload} style={{ opacity: 1, zIndex: 1 }}>
                                    <UploadOutlined style={{ fontSize: '26px' }} /> </span>
                                    <InitUpload onRefresh={(id)=>{onMyselfAvatar(id)}}/>
                                {/* <input className='pos-r' onChange={(e: any) => onUpload(e)} type="file" style={{ opacity: 0, zIndex: 2 }} placeholder='' /> */}
                            </div>
                            {
                                state.userInfo?.avatar ?
                                    <img alt="" className={style.user_default} src={getImgUrlById(tx)} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />

                                    // <img className={style.user_default} src={`./api/rubik/file/${state.userInfo.avatar}/raw?token=${token}`} />
                                    :
                                    // <img alt="" className={style.user_default} src={user_default} />
                                    <UserOutlined className={style.user_default} />
                            }


                        </div>
                    </div>
                    <div data-flex="main:left cross:center" className=' mt-20'>
                        <div className={style.lable}>账户名称</div>
                        {
                            !nameVisible ?
                                <div className={style.itemBox}
                                    onMouseEnter={
                                        () => {
                                            setInfoShow(true)
                                        }}
                                    onMouseLeave={() => {
                                        setInfoShow(false)
                                    }} >
                                    {!infoShow ? <div className={style.item}>{username}</div> :
                                        <Input className={style.input}
                                            onChange={(e) => onChange(e, setUsername)}
                                            disabled={true}
                                            type="text"
                                            autoFocus
                                            value={username}
                                            suffix={
                                                <> <EditFilled className="icon_hover mr-10"
                                                    onClick={(e) => {
                                                        setNameVisible(true)
                                                        setTimeout(() => {
                                                            inputRef.current!.focus({
                                                                preventScroll: true,
                                                            });
                                                        }, 200)

                                                    }}
                                                />
                                                    <KeyOutlined className="icon_hover"
                                                        onClick={(e) => {
                                                            setPassVisible(true)
                                                        }}
                                                    /></>
                                            } />
                                    }
                                </div>
                                :
                                <div style={{ flex: 1 }} onBlur={
                                    () => {
                                        setTimeout(() => {
                                            setNameVisible(false)
                                            setUsername(state.userInfo.username)
                                        }, 500)

                                    }
                                }>
                                    <Input className={style.input}
                                        onChange={(e) => onChange(e, setUsername)}
                                        ref={inputRef}
                                        type="text"
                                        autoFocus
                                        value={username}
                                        suffix={<CheckOutlined className='icon_hover' onMouseDown={(e) => {
                                            e.nativeEvent.stopImmediatePropagation();
                                            onUserName()

                                        }} />

                                        } />
                                </div>
                        }


                    </div>
                    <div data-flex="main:left cross:center" className=' mt-10 cursor'>
                        <div className={style.lable}>我的手机 </div>
                        <div className={style.itemBox} onMouseEnter={
                            () => {
                                setDelPhone(true)
                            }}
                            onMouseLeave={() => {
                                setDelPhone(false)
                            }}>
                            <div className={style.item}>{(state.userInfo?.mobileAccounts || [])[0] ?
                                <span data-flex='main:justify cross:center'><span>{state.userInfo?.mobileAccounts[0]?.mobile}</span>
                                    {
                                        delPhone ? <CloseOutlined onClick={(e) => { e.stopPropagation(); setItemInfo(state.userInfo?.mobileAccounts[0]); setPhoneVisible(true); }} className='icon_hover' /> : ""
                                    }</span> : <LinkOutlined className='icon_hover' onClick={(e) => {
                                        setPhoneVisible(true)
                                    }} />}
                            </div></div>
                    </div>
                    {/* <div data-flex="main:left cross:center" className=' mt-10 cursor'>
                        <div className={style.lable}>我的邮箱</div>
                        <div className={style.itemBox}
                            onMouseEnter={
                                () => {
                                    setDelEmail(true)
                                }}
                            onMouseLeave={() => {
                                setDelEmail(false)
                            }}>
                            <div className={style.item}>{(state.userInfo?.emailAccounts || [])[0] ?
                                <span data-flex='main:justify cross:center'><span>{state.userInfo?.emailAccounts[0]?.email}</span> {
                                    delEmail ? <CloseOutlined onClick={() => { setItemInfo(state.userInfo?.emailAccounts[0]); setEmailVisible(true) }} className='icon_hover' /> : ""
                                } </span> : <LinkOutlined className='icon_hover' onClick={(e) => {
                                    setEmailVisible(true)
                                }} />}
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className='wp-50'>
                    <div data-flex="main:left " className=' mt-10'>
                        <div className={style.lable + ' mt-5'} >GitHub账号</div>
                        <div className={style.itemBox} >
                            {state.net_disk_list.filter(e => e.type === 'SAAS').map((item: any, i: number) => (
                                <div key={i} className={style.item} data-flex='main:justify cross:center' onMouseEnter={
                                    () => { item.select = true; setState({ ...state }) }
                                } onMouseLeave={
                                    () => { item.select = false; setState({ ...state }) }
                                }>
                                    <div>
                                        <img style={{ width: '20px', height: "20px" }} className='mr-10' src={baidu} alt="" /> {item.name}
                                    </div>
                                    {item.select ?
                                        <CloseOutlined onClick={() => { setItemInfo(item); setNetdiskVisible(true) }} className='icon_hover' />
                                        : ''}
                                </div>
                            ))}

                            {
                                state.net_disk_list.filter(e => e.type === 'SAAS').length < 3 ? <>
                                    <div className={style.item} data-flex='main:left cross:center' onClick={() => onAddNetDiskClick()}>
                                        <PlusSquareOutlined style={{ fontSize: '20px', }} className={'icon_hover' + ' mr-10'} />
                                        <span>添加GitHub账号</span>
                                    </div></> : ""
                            }
                        </div>
                    </div>
                </div>

            </div>
            <EditPassWord userInfo={state.userInfo} visible={passVisible} onClose={() => setPassVisible(false)} onRefresh={() => { getInfo() }} />
            <PopCheck title={itemInfo ? '解绑邮箱' : '绑定邮箱'} type={'email'} info={itemInfo} visible={emailVisible} onRefresh={() => { getInfo() }} onClose={() => { setEmailVisible(false); setItemInfo(null) }} />
            <PopCheck title={itemInfo ? '解绑手机' : '绑定手机'} type={'mobile'} info={itemInfo} visible={phoneVisible} onRefresh={() => { getInfo() }} onClose={() => { setPhoneVisible(false); setItemInfo(null) }} />
            <PopCheck title={'确认解绑网盘'} type={'netdisk'} info={itemInfo} visible={netdiskVisible} onRefresh={() => { onEndpoint(); getInfo() }} onClose={() => { setNetdiskVisible(false); setItemInfo(null) }} />
        </Modal>
    )
}

export default MySelf